import { createFileRoute } from "@tanstack/react-router";
import { redirectIntoScope } from "@/app/router/legacy-redirect";

/** Old unscoped URL: `/settings/…` → `/{store}/settings/…`. */
export const Route = createFileRoute("/settings/$")({ beforeLoad: redirectIntoScope });
